export default function(ngModule) {
    ngModule.factory('EventDate', function(BaseClass, $q, $http, $injector, sortByPredecessor, Role) {

        /**
         * Constructor function
         *
         * @constructor
         * @param {Object} attributes Initial attributes for the model
         */
        function EventDate(attributes) {
            _.assign(this,attributes);
        }

        EventDate.modelName = 'EventDate';
        EventDate.dateFormat = 'YYYY-MM-DDTHH:mm:ssZ';

        BaseClass.apply(EventDate);

        EventDate.configureApi('/eventdate/:guid');
        EventDate.configureAPIMessages({
            'POST /product/:product_guid/dates/:guid': {
                406: 'models.product.notice.dateAlreadyAttached'
            },
            'DELETE /product/:product_guid/dates/:guid': {
                406: 'models.product.notice.dateNotAttached'
            }
        });

        EventDate.prototype.toString = function() {
            return this.dates;
        };

        Object.defineProperty(EventDate.prototype, 'dates', {
            get: function() {
                return moment(this.start).format('DD/MM HH:mm') + ' - ' + moment(this.end).format('DD/MM HH:mm');
            },
            enumerable: false
        });

        EventDate.belongsTo('Event', 'event_id', 'guid','/event/^guid/');
        EventDate.belongsToMany('Product', 'products','/eventdate/:guid/products', [{type: 'query'}]);

        EventDate.belongsToMany('MetaData','meta_data','/product/:guid/metaData/^guid',[
            {
                type: 'query',
                success: meta => sortByPredecessor(meta)
            },
            { type: 'attach' },
            { type: 'detach' },
            { type: 'reorder', url: '/product/:guid/metaData/reorder' }
        ]);

        EventDate.validates({
            name: {
                required: true
            },
            start: {
                required: true,
                format: {
                    regex: {
                        regex: /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}[+-]\d{2}:\d/,
                        message: 'must be a valid date'
                    }
                },
                notInPast: {
                    validator: function(value) {
                        if(Role.isAuthorizedAs('Admin')) {
                            return true;
                        }

                        if(!value || !value.length) {
                            return true;
                        }

                        return moment(value, EventDate.dateFormat).isAfter(moment());
                    },
                    message: 'must be in the future'
                }
            },
            end: {
                required: true,
                format: {
                    regex: {
                        regex: /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}[+-]\d{2}:\d/,
                        message: 'must be a valid date'
                    }
                },
                isAfter: {
                    validator: function(value, instance, field) {
                        if(!value || !value.length) {
                            return true;
                        }

                        return moment(value, EventDate.dateFormat).isAfter(moment(instance.start, EventDate.dateFormat));
                    },
                    message: 'must be after start'
                }
            },
            capacity: {
                required: true,
                integer: true
            },
            event_id: {
                required: true
            }
        });

        return EventDate;
    });
}
